import React, { useEffect, useRef } from "react";
// Import SvgWhiteLogo from your SVG component
import "../Login/index.scss"; // Import your custom styles
// import SvgWhiteLogo from '../../../assets/icons/SvgWhiteLogo';
import InputField from "../../../components/InputField";
import { Button } from "primereact/button";
import SvgWhiteLogo from "../../../assets/icons/SvgWhiteLogo";
import SvgLogo from "../../../assets/icons/SvgLogo";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { TOKEN } from "../../../utility/constant";
import Cookies from "js-cookie";
import { useFormik } from "formik";
import CustomToast from "../../../components/Toast";
import InputTextField from "../../component/inputText";
import captionImage from "../../../assets/images/agent-login-caption-image.png";
const toyotaBannerImage = "/toyota-banner.jpg";
const initialValue = {
  EmailAddress: "",
  Password: "",
};

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  // const token = Cookies.get(TOKEN);
  const toastRef = useRef(null);

  const validate = (values) => {
    const errors = {};

    if (!values.EmailAddress) {
      errors.EmailAddress = "User ID is required";
    } 
    // else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.EmailAddress)) {
    //   errors.EmailAddress = "Invalid email address";
    // }

    if (!values.Password) {
      errors.Password = "Password is required";
    } else if (values.Password.length < 6) {
      errors.Password = "Password must be at least 6 characters";
    }

    return errors;
  };

  const handleNavigate = () => {
    navigate("register");
  };

  const handleSubmit = (values) => {
    console.log(values, "values");
    // Check for ITADMIN (admin user)
    if (
      values.EmailAddress === "ITADMIN" &&
      values.Password === "Test@123"
    ) {
      Cookies.set(TOKEN, "token");
      Cookies.set("USER_ROLE", "admin");
      Cookies.set("USER_NAME", "IT Administrator");
      toastRef.current.showToast();
      navigate("/");
      setTimeout(() => {
        window.location.reload();
      }, 500);
    }
    // Check for regular user (all edit permissions except masters)
    else if (
      values.EmailAddress === "user" &&
      values.Password === "User@123"
    ) {
      Cookies.set(TOKEN, "token");
      Cookies.set("USER_ROLE", "user");
      Cookies.set("USER_NAME", "Standard User");
      toastRef.current.showToast();
      navigate("/");
      setTimeout(() => {
        window.location.reload();
      }, 500);
    } else {
      // Invalid credentials
    }
  };
  useEffect(() => {
    console.log('testing')
    if (location.pathname === "/login" && Cookies.get(TOKEN)) {
      navigate("/");
    }
    if (location.pathname === "/" && Cookies.get(TOKEN) === undefined) {
      navigate("/login");
    }
  });
 

  const formik = useFormik({
    initialValues: initialValue,
    validate,
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });
  return (
    <Routes>
      <Route
        path="/login"
        element={
          <div className="grid m-0 agent__container__login">
            <CustomToast ref={toastRef} message="Login Successfully" />
            <div className="col-12 md:col-8 left__side__login toyota-theme">
              <div className="toyota-content-overlay">
                <div className="toyota-tagline">
                  <h1>Drive with Confidence</h1>
                  <p>Toyota Insurance - Comprehensive coverage for your journey ahead.</p>
                </div>
              </div>
              <div className="toyota-banner-container">
                <img src={toyotaBannerImage} alt="Toyota Insurance" className="toyota-banner-image" />
              </div>
              <div className="powered-by-footer">
                <span>Powered by iortaTechNxt - iNxt Brokerverse</span>
              </div>
            </div>
            <div className="col-12 md:col-4 login__side__screen p-5">
              <div className="col-12 md:col-12 lg:col-12 toyota-logo-container">
                <img src="/toyota.png" alt="Toyota Logo" className="toyota-logo" />
              </div>
              <div className="col-12 md:col-12 lg:col-12  ">
                <div className="login__header">Log in to Toyota Insurance</div>
              </div>

              <div className="col-12 md:col-12 lg:col-12  ">
                <InputTextField
                  label="User ID"
                  value={formik.values.EmailAddress}
                  onChange={formik.handleChange("EmailAddress")}
                />
                {formik.touched.EmailAddress && formik.errors.EmailAddress && (
                  <div style={{ fontSize: 12, color: "red" }} className="mt-1">
                    {formik.errors.EmailAddress}
                  </div>
                )}
              </div>
              <div className="col-12 md:col-12 lg:col-12  ">
                <InputTextField
                  label="Password"
                  value={formik.values.Password}
                  onChange={formik.handleChange("Password")}
                />
                {formik.touched.Password && formik.errors.Password && (
                  <div style={{ fontSize: 12, color: "red" }} className="mt-1">
                    {formik.errors.Password}
                  </div>
                )}
              </div>
              <div className="col-12 md:col-12 lg:col-12  ">
                <Button
                  className="login__button toyota-login-btn"
                  onClick={() => formik.handleSubmit()}
                >
                  Login
                </Button>
              </div>
              <div className="col-12 md:col-12 lg:col-12  ">
                <div className="forget__text cursor-pointer">
                  Forgot password?
                </div>
              </div>
              <div className="col-12 md:col-12 lg:col-12 tech-footer">
                <div className="tech-powered-text">
                  Powered by <strong>iortaTechNxt</strong> - iNxt Brokerverse
                </div>
              </div>
            </div>
          </div>
        }
      />
    </Routes>
  );
};

export default Login;
